/**
 * Collapsed author line for the block-page work cards/rows: the first author's
 * name plus a "+N more" suffix ("Jane Doe +2 more"). Shared by the tabs hero
 * and the pack-preview rows so the format can't drift between variants
 * (liswp_blocks/AGENTS.md Rule 2). The related_papers grid card renders the
 * same collapsed format, but composes it itself so the first author's name can
 * be the hoverable BlockAuthorLink.
 */
export function authorLine(authors: Array<{ displayName: string }>): string {
  if (!authors.length) return '';
  const [first, ...rest] = authors;
  return rest.length > 0
    ? `${first.displayName} +${rest.length} more`
    : first.displayName;
}
